export default "__VITE_ASSET__Cbx3iQGH__"